import * as Yup from 'yup';

const editReplyValidationSchema = Yup.object().shape({
  content: Yup.string().required('Please enter your reply')
});

export default editReplyValidationSchema;
